"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliverableState = void 0;
const luxon_1 = require("luxon");
const Creative_1 = require("./Creative");
class Deliverable {
    constructor({ id, creative, attachedThumbnail, intent, state, uploadedAdPlatformKeys, createdAt, stateUpdatedAt, }) {
        this.toJSON = () => {
            const attacehdThumbnail = this.attachedThumbnail ? this.attachedThumbnail.toJSON() : this.attachedThumbnail;
            return {
                id: this.id,
                creative: this.creative.toJSON(),
                attachedThumbnail: attacehdThumbnail,
                intent: this.intent,
                state: this.state,
                uploadedAdPlatformKeys: this.uploadedAdPlatformKeys || undefined,
                createdAt: this.createdAt.toISO(),
                stateUpdatedAt: this.stateUpdatedAt.toISO(),
            };
        };
        this.id = id;
        this.creative = creative;
        this.attachedThumbnail = attachedThumbnail;
        this.intent = intent;
        this.state = state;
        this.uploadedAdPlatformKeys = uploadedAdPlatformKeys;
        this.createdAt = createdAt;
        this.stateUpdatedAt = stateUpdatedAt;
    }
    get modificationRequestExpiredAt() {
        return this.createdAt.plus({ days: 11 });
    }
}
Deliverable.fromJSON = (json) => {
    const { id, creative, attachedThumbnail, intent, state, uploadedAdPlatformKeys, createdAt, stateUpdatedAt, } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof intent !== 'string')
        throw new Error('.intent must be a string');
    if (typeof state !== 'string')
        throw new Error('.state must be a string for state');
    if (typeof createdAt !== 'string')
        throw new Error('.createdAt must be a string');
    if (typeof stateUpdatedAt !== 'string')
        throw new Error('.stateUpdatedAt must be a string');
    const _attacehdThumbnail = attachedThumbnail ? Creative_1.default.fromJSON(attachedThumbnail) : null;
    return new Deliverable({
        id,
        creative: Creative_1.default.fromJSON(creative),
        attachedThumbnail: _attacehdThumbnail,
        intent,
        state: deserializeToDeliverableState(state),
        uploadedAdPlatformKeys,
        createdAt: luxon_1.DateTime.fromISO(createdAt),
        stateUpdatedAt: luxon_1.DateTime.fromISO(stateUpdatedAt),
    });
};
const deserializeToDeliverableState = (str) => {
    if (Object.keys(exports.DeliverableState).indexOf(str) === -1) {
        throw new Error(`str must be a one of ${Object.keys(exports.DeliverableState).join(', ')}`);
    }
    return str;
};
exports.DeliverableState = {
    submitted: 'submitted',
    modification_requested: 'modification_requested',
    inspection_modification_requested: 'inspection_modification_requested',
    approved: 'approved',
};
exports.default = Deliverable;
